"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _socket = _interopRequireDefault(require("socket.io-client"));
var _dmet = require("./dmet");
var _singleInstance = _interopRequireDefault(require("../core/singleInstance"));
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _cvSocket = /*#__PURE__*/new WeakMap();
var _data = /*#__PURE__*/new WeakMap();
var _defaultData = /*#__PURE__*/new WeakMap();
var _CloudVariableExtension_brand = /*#__PURE__*/new WeakSet();
var CloudVariableExtension = /*#__PURE__*/function () {
  function CloudVariableExtension() {
    (0, _classCallCheck2["default"])(this, CloudVariableExtension);
    _classPrivateMethodInitSpec(this, _CloudVariableExtension_brand);
    _classPrivateFieldInitSpec(this, _cvSocket, null);
    _classPrivateFieldInitSpec(this, _data, null);
    _classPrivateFieldInitSpec(this, _defaultData, null);
  }
  return (0, _createClass2["default"])(CloudVariableExtension, [{
    key: "data",
    get: function get() {
      return _classPrivateFieldGet(_data, this);
    }
  }, {
    key: "setServerInfo",
    value: function setServerInfo(cvServer) {
      this.cvServer = cvServer;
    }
  }, {
    key: "disable",
    value: function disable(target) {
      if (!_classPrivateFieldGet(_cvSocket, this)) {
        return;
      }
      _classPrivateFieldGet(_cvSocket, this).emit('changeMode', 'offline', target);
    }
  }, {
    key: "enable",
    value: function enable(target) {
      if (!_classPrivateFieldGet(_cvSocket, this)) {
        return;
      }
      _classPrivateFieldGet(_cvSocket, this).emit('changeMode', 'online', target);
    }
  }, {
    key: "connect",
    value: function () {
      var _connect = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(cvServer) {
        var _this = this;
        var _this$cvServer, url, query, type, socket;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(_classPrivateFieldGet(_cvSocket, this) || !this.cvServer)) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              _this$cvServer = this.cvServer, url = _this$cvServer.url, query = _this$cvServer.query, type = _this$cvServer.type;
              socket = (0, _socket["default"])(url, {
                path: '/cv',
                query: {
                  type: type,
                  q: query
                },
                transports: ['websocket'],
                reconnectionAttempts: 2,
                timeout: 5000
              });
              socket.on('action', _assertClassBrand(_CloudVariableExtension_brand, this, _execDmet).bind(this));
              socket.on('create', _assertClassBrand(_CloudVariableExtension_brand, this, _createVariable).bind(this));
              socket.on('reset', function (variables) {
                try {
                  _classPrivateFieldSet(_data, _this, new _dmet.dmet(variables));
                } catch (e) {
                  console.warn(e);
                }
              });
              _classPrivateFieldSet(_cvSocket, this, socket);
              return _context.abrupt("return", new Promise(function (resolve) {
                socket.on('connect_error', function () {
                  console.log('connect_error');
                  if (!_classPrivateFieldGet(_data, _this)) {
                    try {
                      _classPrivateFieldSet(_data, _this, new _dmet.dmet(_classPrivateFieldGet(_defaultData, _this)));
                    } catch (e) {
                      console.warn(e);
                    }
                    resolve();
                  }
                });
                socket.on('check', function (id) {
                  socket.emit('imAlive', id);
                });
                socket.on('welcome', function (_ref) {
                  var _ref$variables = _ref.variables,
                    variables = _ref$variables === void 0 ? [] : _ref$variables,
                    isOffline = _ref.isOffline;
                  try {
                    _classPrivateFieldSet(_data, _this, new _dmet.dmet(variables));
                    variables.forEach(_assertClassBrand(_CloudVariableExtension_brand, _this, _applyValue));
                  } catch (e) {
                    console.warn(e);
                  }
                  if (isOffline) {
                    socket.close();
                  }
                  resolve();
                });
                socket.on('disconnect', function (reason) {
                  console.log('disconnect', reason);
                  if (!_classPrivateFieldGet(_data, _this)) {
                    _classPrivateFieldSet(_data, _this, new _dmet.dmet(_classPrivateFieldGet(_defaultData, _this)));
                  }
                  resolve();
                });
                socket.on('changeMode', function (mode, target) {
                  var isOffline = mode === 'offline';
                  if (isOffline) {
                    socket.close();
                  }
                  resolve();
                });
              }));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function connect(_x) {
        return _connect.apply(this, arguments);
      }
      return connect;
    }()
  }, {
    key: "setDefaultData",
    value: function setDefaultData(defaultData) {
      _classPrivateFieldSet(_defaultData, this, defaultData);
      defaultData.forEach(_assertClassBrand(_CloudVariableExtension_brand, this, _applyValue));
    }
  }, {
    key: "createDmet",
    value: function createDmet(object) {
      _classPrivateFieldGet(_data, this).create(object);
    }
  }, {
    key: "create",
    value: function () {
      var _create = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(data) {
        var id_, type, name;
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (_classPrivateFieldGet(_cvSocket, this)) {
                _context2.next = 1;
                break;
              }
              _context2.next = 1;
              return this.connect();
            case 1:
              id_ = data.id_, type = data.type, name = data.name;
              if (!(type === 'variable')) {
                _context2.next = 3;
                break;
              }
              _context2.next = 2;
              return _assertClassBrand(_CloudVariableExtension_brand, this, _createVariable).call(this, name, id_);
            case 2:
              _context2.next = 6;
              break;
            case 3:
              if (!(type === 'list')) {
                _context2.next = 5;
                break;
              }
              _context2.next = 4;
              return _assertClassBrand(_CloudVariableExtension_brand, this, _createList).call(this, name, id_);
            case 4:
              _context2.next = 6;
              break;
            case 5:
              if (!(type === 'table')) {
                _context2.next = 6;
                break;
              }
              _context2.next = 6;
              return _assertClassBrand(_CloudVariableExtension_brand, this, _createTable).call(this, name, id_);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function create(_x2) {
        return _create.apply(this, arguments);
      }
      return create;
    }()
  }, {
    key: "set",
    value: function set(target, value) {
      if (!_classPrivateFieldGet(_cvSocket, this)) {
        return;
      }
      var variable = _classPrivateFieldGet(_data, this) && _classPrivateFieldGet(_data, this).get(target);
      if (!variable) {
        return;
      }
      var operation = variable.getOperation({
        type: 'set',
        value: value
      });
      return _assertClassBrand(_CloudVariableExtension_brand, this, _run).call(this, operation);
    }
  }, {
    key: "get",
    value: function get(target) {
      return _classPrivateFieldGet(_data, this) && _classPrivateFieldGet(_data, this).get(target);
    }

    // 워크스페이스에서만 동작하는 함수이기 때문에 run 생략
  }, {
    key: "setArray",
    value: function setArray(target, array) {
      var dmetList = _classPrivateFieldGet(_data, this) && _classPrivateFieldGet(_data, this).get(target);
      if (!dmetList) {
        console.error('no target ', target);
      }
      dmetList.from(array.map(function (_ref2) {
        var data = _ref2.data;
        return data;
      }));
    }
  }, {
    key: "append",
    value: function append(target, data) {
      var _ref3;
      if (!_classPrivateFieldGet(_cvSocket, this)) {
        return;
      }
      var variable = (_ref3 = this === null || this === void 0 ? void 0 : _classPrivateFieldGet(_data, this)) === null || _ref3 === void 0 ? void 0 : _ref3.get(target);
      if (!variable) {
        return;
      }
      var operation = variable.getOperation({
        type: 'append',
        data: data
      });
      return _assertClassBrand(_CloudVariableExtension_brand, this, _run).call(this, operation);
    }
  }, {
    key: "insert",
    value: function insert(target, index, data) {
      if (!_classPrivateFieldGet(_cvSocket, this)) {
        return;
      }
      var variable = _classPrivateFieldGet(_data, this).get(target);
      if (!variable) {
        return;
      }
      var operation = variable.getOperation({
        type: 'insert',
        index: index,
        data: data
      });
      return _assertClassBrand(_CloudVariableExtension_brand, this, _run).call(this, operation);
    }
  }, {
    key: "delete",
    value: function _delete(target, index) {
      if (!_classPrivateFieldGet(_cvSocket, this)) {
        return;
      }
      var variable = _classPrivateFieldGet(_data, this).get(target);
      if (!variable) {
        return;
      }
      var operation = variable.getOperation({
        type: 'delete',
        index: index
      });
      return _assertClassBrand(_CloudVariableExtension_brand, this, _run).call(this, operation);
    }
  }, {
    key: "replace",
    value: function replace(target, index, data) {
      if (!_classPrivateFieldGet(_cvSocket, this)) {
        return;
      }
      var variable = _classPrivateFieldGet(_data, this).get(target);
      if (!variable) {
        return;
      }
      var operation = variable.getOperation({
        type: 'replace',
        index: index,
        data: data
      });
      return _assertClassBrand(_CloudVariableExtension_brand, this, _run).call(this, operation);
    }
  }]);
}();
function _createVariable(name, id) {
  var _this2 = this;
  if (!_classPrivateFieldGet(_cvSocket, this)) {
    return;
  }
  var variable = new _dmet.dmetVariable({
    name: name
  }, id);
  return new Promise(function (resolve) {
    _classPrivateFieldGet(_cvSocket, _this2).emit('create', variable, function (isCreate, variable) {
      if (isCreate) {
        _this2.createDmet(variable);
      }
      resolve();
    });
  });
}
function _createList(name, id) {
  var _this3 = this;
  if (!_classPrivateFieldGet(_cvSocket, this)) {
    return;
  }
  var list = new _dmet.dmetList({
    name: name
  }, id);
  return new Promise(function (resolve) {
    _classPrivateFieldGet(_cvSocket, _this3).emit('create', list, function (isCreate, list) {
      if (isCreate) {
        _this3.createDmet(list);
      }
      resolve();
    });
  });
}
function _createTable(name, id) {
  var _this4 = this;
  if (!_classPrivateFieldGet(_cvSocket, this)) {
    return;
  }
  var table = new _dmet.dmetTable({
    name: name
  }, id);
  return new Promise(function (resolve) {
    _classPrivateFieldGet(_cvSocket, _this4).emit('create', table, function (isCreate, table) {
      if (isCreate) {
        _this4.createDmet(table);
      }
      resolve();
    });
  });
}
function _run(operation) {
  var _this5 = this;
  return new Promise(function (resolve) {
    if (_classPrivateFieldGet(_cvSocket, _this5).connected) {
      _classPrivateFieldGet(_cvSocket, _this5).emit('action', operation, function (isUpdate, operation) {
        if (isUpdate) {
          _classPrivateFieldGet(_data, _this5).exec(operation);
          resolve(operation);
        } else {
          resolve();
        }
      });
    } else {
      _classPrivateFieldGet(_data, _this5).exec(operation);
      resolve(operation);
    }
  }).then(function (operation) {
    if (operation) {
      _assertClassBrand(_CloudVariableExtension_brand, _this5, _applyValue).call(_this5, operation);
    }
  });
}
function _execDmet(operation) {
  _classPrivateFieldGet(_data, this).exec(operation);
  _assertClassBrand(_CloudVariableExtension_brand, this, _applyValue).call(this, operation);
}
function _applyValue(operation) {
  var id = operation.id,
    value = operation.value,
    data = operation.data,
    variableType = operation.variableType;
  if (variableType === 'variable' || variableType === 'slide') {
    var variable = Entry.variableContainer.getVariable(id);
    if (variable) {
      variable.value_ = value;
      variable._valueWidth = null;
      variable.updateView();
    }
  } else if (variableType === 'list') {
    var list = Entry.variableContainer.getList(id);
    if (!list) {
      return;
    }
    if (this && this.get) {
      var _this$get = this.get(operation),
        array = _this$get.array;
      list.array_ = array;
    } else if (operation.array) {
      list.array_ = operation.array;
    } else if (operation.list) {
      list.array_ = operation.list.map(function (key) {
        return {
          data: operation.value[key]
        };
      });
    }
    list.updateView();
  }
}
var _default = exports["default"] = (0, _singleInstance["default"])(CloudVariableExtension);